import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import LoaderWrapper from "../../../Utils/ViewWrapper/LoaderWrapper/LoaderWrapper";
import { useTranslation } from "react-i18next";
import { getProspectUsers } from "../../../REDUX/actions/prospects";
import ProspectUserCard from "./ProspectUserCard";

function ProspectUsersContent() {
  const { t } = useTranslation("common");
  const { id } = useParams();
  const dispatch = useDispatch();
  const { prospectUsers, prospectUsersLoading } = useSelector(
    (state) => state.prospectsReducer
  );
  console.log(prospectUsers);

  useEffect(() => {
    dispatch(getProspectUsers(id));
  }, [dispatch, id]);

  return (
    <div className="flex-1">
      <div className="row bg-dimGrey py-3 px-4 mx-0 w-100 d-flex justify-content-between align-items-center">
        <span className="col-3 text-brightGrey sBold f14">
          {t("Last name")}
        </span>
        <span className="col-3 text-brightGrey sBold f14">
          {t("First name")}
        </span>
        <span className="col-2 text-brightGrey sBold f14">
          {t("Phone number")}
        </span>
        <span className="col-3 text-brightGrey sBold f14">{t("E-mail")}</span>
        <span className="col-1 text-brightGrey sBold f14"></span>
      </div>

      <LoaderWrapper loading={prospectUsersLoading}>
        {prospectUsers?.map((user) => (
          <div key={user?.id}>
            <ProspectUserCard id={user?.id} {...user} />
            <hr style={{ borderColor: "#abb8b2", margin: 0 }} width={"100%"} />
          </div>
        ))}
      </LoaderWrapper>
    </div>
  );
}

export default ProspectUsersContent;
